import React from 'react';
import { isMobileAtom } from '@atoms/appSettings';
import { isNavbarDisabledAtom } from '@atoms/navigation';
import loadable from '@loadable/component';
import { useAtom } from 'jotai';

const NavigationBarLoadable = loadable(() => import('./NavigationBar'));
const MobileNavigationBarLoadable = loadable(() => import('./MobileNavigationBar'));
const LanguageSuggestionBannerLoadable = loadable(() => import('./LanguageSuggestionBanner'));

export function AccessibleNav(): React.ReactElement {
    const [isMobile] = useAtom(isMobileAtom);
    const [isNavbarDisabled] = useAtom(isNavbarDisabledAtom);

    return (
        <>
            {!isNavbarDisabled ? isMobile ? (
                <MobileNavigationBarLoadable />
            ) : (
                <NavigationBarLoadable />
            ) : null}
            <LanguageSuggestionBannerLoadable />
        </>
    );
}
